import { BenQuery } from '@/js/BenQuery'

type Modal = { key: number; zIndex: number; $moveWrap: HTMLElement; $closeBtn: HTMLElement; $sizeMaxBtn: HTMLElement; $sizeReturnBtn: HTMLElement; $target: HTMLElement; status: 'default' | 'sizeMax'; left: number; top: number; width: number; height: number; minWidth: number; minHeight: number; marginTop: number; marginLeft: number; marginBottom: number; marginRight: number; sizeChangeOriginal: { left: number; top: number; width: number; height: number }; visibility: 'visible' | 'hidden'; RTL: boolean }
export class BenModalFn {
  private static render(modalObj: Modal) {
    const { top, left, width, height, $target, $sizeMaxBtn, $sizeReturnBtn, status } = modalObj
    _css($target, { top, insetInlineStart: left, width, height })
    if (status === 'sizeMax') {
      if ($sizeMaxBtn) $sizeMaxBtn.style.display = 'none'
      if ($sizeReturnBtn) $sizeReturnBtn.style.display = 'block'
    } else if (status === 'default') {
      if ($sizeMaxBtn) $sizeMaxBtn.style.display = 'block'
      if ($sizeReturnBtn) $sizeReturnBtn.style.display = 'none'
    }
  }

  static getScreenSize() {
    const screenWidth = document.documentElement.clientWidth
    const screenHeight = document.documentElement.clientHeight
    return { screenHeight, screenWidth }
  }

  static init($target: HTMLElement, { key = 0, zIndex = 0, sizeCtrl = true, moveWrapClass = '.moveWrap', closeBtnClass = '.closeBtn', sizeMaxBtnClass = '.sizeMaxBtn', sizeReturnBtnClass = '.sizeReturnBtn', minWidth = 300, minHeight = 200, marginLeft = 0, marginRight = 0, marginTop = 0, marginBottom = 0 }) {
    const width = $target.offsetWidth
    const height = $target.offsetHeight
    const { screenHeight, screenWidth } = BenModalFn.getScreenSize()
    const RTL = BenQuery.isRTL($target)
    let left = $target.offsetLeft
    const top = $target.offsetTop
    if (RTL) left = screenWidth - left - width
    const $moveWrap = $target.querySelector(moveWrapClass) as HTMLElement
    const $closeBtn = $target.querySelector(closeBtnClass) as HTMLElement
    const $sizeMaxBtn = $target.querySelector(sizeMaxBtnClass) as HTMLElement
    const $sizeReturnBtn = $target.querySelector(sizeReturnBtnClass) as HTMLElement
    const modalObj: Modal = { key, zIndex, $moveWrap, $closeBtn, $sizeMaxBtn, $sizeReturnBtn, $target, status: 'default', left, top, width, height, minHeight, minWidth, marginTop, marginLeft, marginBottom, marginRight, sizeChangeOriginal: { left: 0, top: 0, width: 0, height: 0 }, visibility: 'visible', RTL }
    _css($target, { position: 'fixed', insetInlineStart: left, top, boxSizing: 'border-box' })
    _css($moveWrap, { cursor: 'move' })
    if ($sizeReturnBtn) $sizeReturnBtn.style.display = 'none'

    //btn events
    $sizeMaxBtn?.addEventListener('click', (e) => {
      this.sizeMax(modalObj)
      e.stopImmediatePropagation()
      return false
    })
    $sizeReturnBtn?.addEventListener('click', (e) => {
      BenModalFn.sizeReturn(modalObj)
      e.stopImmediatePropagation()
      return false
    })
    $moveWrap.addEventListener('dblclick', (event) => {
      event.preventDefault()
      event.stopPropagation()
      return false
    })
    //can remove init
    $moveWrap.addEventListener('mousedown', (e) => {
      e.preventDefault()
      e.stopPropagation()
      const { pageX, pageY } = e
      let distX = pageX - modalObj.left
      if (RTL) distX = pageX - (screenWidth - width - modalObj.left)
      const distY = pageY - modalObj.top
      const event = BenModalFn.eventDocumentMouseMoveCreate(modalObj, distX, distY)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', (e) => {
        e.preventDefault()
        e.stopPropagation()
        const { width, height } = modalObj
        const { screenWidth, screenHeight } = BenModalFn.getScreenSize()
        let { left, top } = modalObj
        const maxX = screenWidth - width - marginRight
        const maxY = screenHeight - height - marginBottom
        if (left > maxX) left = maxX
        if (top > maxY) top = maxY
        if (left < marginLeft) left = marginLeft
        if (top < marginTop) top = marginTop
        modalObj.left = left
        modalObj.top = top
        BenModalFn.render(modalObj)
        document.removeEventListener('mousemove', event)
      })
    })
    //init resize control div
    const ctrTop = document.createElement('div')
    ctrTop.className = 'BenModalSuper-ctrTop'
    const ctrRight = document.createElement('div')
    ctrRight.className = 'BenModalSuper-ctrRight'
    const ctrBottom = document.createElement('div')
    ctrBottom.className = 'BenModalSuper-ctrBottom'
    const ctrLeft = document.createElement('div')
    ctrLeft.className = 'BenModalSuper-ctrLeft'
    const commonStyle = { position: 'absolute', zIndex: 100 }
    const whSize = 5
    _css(ctrTop, { ...commonStyle, top: 0, left: 0, height: whSize, width: '100%', cursor: 'n-resize' })
    _css(ctrBottom, { ...commonStyle, bottom: 0, left: 0, height: whSize, width: '100%', cursor: 'n-resize' })
    _css(ctrLeft, { ...commonStyle, top: 0, left: 0, height: '100%', width: whSize, cursor: 'w-resize' })
    _css(ctrRight, { ...commonStyle, top: 0, right: 0, height: '100%', width: whSize, cursor: 'w-resize' })
    if (sizeCtrl === true) {
      $target.appendChild(ctrTop)
      $target.appendChild(ctrRight)
      $target.appendChild(ctrBottom)
      $target.appendChild(ctrLeft)
    }
    ctrTop.addEventListener('mousedown', (e) => {
      const { pageY } = e
      e.preventDefault()
      e.stopPropagation()
      const event = BenModalFn.eventDocumentMouseMoveCreateCtrTop(modalObj, pageY)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', event)
      })
    })
    ctrBottom.addEventListener('mousedown', (e) => {
      const { pageY } = e
      e.preventDefault()
      e.stopPropagation()
      const event = BenModalFn.eventDocumentMouseMoveCreateCtrBottom(modalObj, pageY)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', event)
      })
    })
    ctrLeft.addEventListener('mousedown', (e) => {
      const { pageX } = e
      e.preventDefault()
      e.stopPropagation()
      const event = BenModalFn.eventDocumentMouseMoveCreateCtrLeft(modalObj, pageX)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', event)
      })
    })
    ctrRight.addEventListener('mousedown', (e) => {
      const { pageX } = e
      e.preventDefault()
      e.stopPropagation()
      const event = BenModalFn.eventDocumentMouseMoveCreateCtrRight(modalObj, pageX)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', (e) => {
        e.preventDefault()
        e.stopPropagation()
        document.removeEventListener('mousemove', event)
      })
    })
    //init right bottom resize controll div
    const eleCtrRightBottom = document.createElement('div')
    eleCtrRightBottom.className = 'BenModalSuper-ctrRightBottom'
    _css(eleCtrRightBottom, { position: 'absolute', width: 8, height: 8, right: 0, bottom: 0, cursor: 'se-resize', zIndex: 101 })
    if (sizeCtrl === true) $target.append(eleCtrRightBottom)
    eleCtrRightBottom.addEventListener('mousedown', (e) => {
      const { pageX, pageY } = e
      e.preventDefault()
      e.stopPropagation()
      const event = BenModalFn.eventDocumentMouseMoveCreateCtrRightBottom(modalObj, pageX, pageY)
      document.addEventListener('mousemove', event)
      document.addEventListener('mouseup', (e) => {
        e.preventDefault()
        e.stopPropagation()
        document.removeEventListener('mousemove', event)
      })
    })
    return modalObj
  }

  /** to max */
  static sizeMax(modalObj: Modal) {
    const { marginLeft, marginRight, marginTop, marginBottom, sizeChangeOriginal } = modalObj
    sizeChangeOriginal.top = modalObj.top
    sizeChangeOriginal.left = modalObj.left
    sizeChangeOriginal.width = modalObj.width
    sizeChangeOriginal.height = modalObj.height
    const { screenWidth, screenHeight } = BenModalFn.getScreenSize()
    const width = screenWidth - marginLeft - marginRight
    const height = screenHeight - marginTop - marginBottom
    const left = marginLeft
    const top = marginTop
    modalObj.left = left
    modalObj.top = top
    modalObj.width = width
    modalObj.height = height
    modalObj.status = 'sizeMax'
    BenModalFn.render(modalObj)
  }
  /** to max */
  static sizeReturn(modalObj: Modal) {
    const { sizeChangeOriginal, status } = modalObj
    if (status === 'default') return
    modalObj.top = sizeChangeOriginal.top
    modalObj.left = sizeChangeOriginal.left
    modalObj.width = sizeChangeOriginal.width
    modalObj.height = sizeChangeOriginal.height
    modalObj.status = 'default'
    BenModalFn.render(modalObj)
  }

  /** create document mouse move event when ctrTop mousedown */
  private static eventDocumentMouseMoveCreateCtrTop(modalObj: Modal, pageYOld) {
    const { minHeight, marginTop, height: heightOld } = modalObj
    const minY = marginTop + document.documentElement.scrollTop
    const scrollTop = document.documentElement.scrollTop
    return (event) => {
      const { pageY } = event
      const distY = pageY - pageYOld
      let height = heightOld - distY
      if (height > minHeight && pageY > marginTop) {
        modalObj.top = pageY - scrollTop
        modalObj.height = height
      } else if (pageY <= minY) {
        modalObj.top = minY
      } else if (height <= minHeight) {
        modalObj.height = minHeight
      }
      BenModalFn.render(modalObj)
      event.preventDefault()
      return false
    }
  }

  /** create document mouse move event when ctrBottom mousedown */
  private static eventDocumentMouseMoveCreateCtrBottom(modalObj: Modal, pageYOld) {
    const { minHeight, marginBottom, height: heightOld } = modalObj
    return (event) => {
      const { pageY } = event
      const distY = pageY - pageYOld
      let height = heightOld + distY
      const { screenHeight } = BenModalFn.getScreenSize()
      const maxY = screenHeight - marginBottom + document.documentElement.scrollTop
      if (height > minHeight && pageY < maxY) {
        modalObj.height = height
      } else if (height <= minHeight) {
        modalObj.height = minHeight
      } else if (pageY >= maxY) {
        modalObj.height = heightOld + (maxY - pageYOld)
      }
      BenModalFn.render(modalObj)
      event.preventDefault()
      return false
    }
  }

  /** create document mouse move event when ctrLeft mousedown */
  private static eventDocumentMouseMoveCreateCtrLeft(modalObj: Modal, pageXOld) {
    const { minWidth, marginLeft, width: widthOld } = modalObj
    return (event) => {
      const { pageX } = event
      const distX = pageX - pageXOld
      let width = widthOld - distX
      if (width > minWidth && pageX > marginLeft) {
        modalObj.left = pageX
        modalObj.width = width
      } else if (width <= minWidth) {
        modalObj.width = minWidth
      } else if (pageX <= marginLeft) {
        modalObj.left = marginLeft
      }
      BenModalFn.render(modalObj)
      event.preventDefault()
      return false
    }
  }

  /** create document mouse move event when ctrRight mousedown */
  private static eventDocumentMouseMoveCreateCtrRight(modalObj: Modal, pageXOld) {
    const { minWidth, marginRight, width: widthOld } = modalObj
    return (event) => {
      event.preventDefault()
      event.stopPropagation()
      const { pageX } = event
      const distX = pageX - pageXOld
      let width = widthOld + distX
      const { screenWidth, screenHeight } = BenModalFn.getScreenSize()
      const maxX = screenWidth - marginRight
      if (width > minWidth && pageX < maxX) {
        modalObj.width = width
      } else if (width <= minWidth) {
        modalObj.width = minWidth
      } else if (pageX >= maxX) {
        modalObj.width = widthOld + (maxX - pageXOld)
      }
      BenModalFn.render(modalObj)
      return false
    }
  }

  /** create document mouse move event when ctrRightBottom mousedown */
  private static eventDocumentMouseMoveCreateCtrRightBottom(modalObj: Modal, pageXOld, pageYOld) {
    const { marginBottom, marginRight, minWidth, minHeight, width: widthOld, height: heightOld } = modalObj
    return (event) => {
      event.preventDefault()
      event.stopPropagation()
      const { pageX, pageY } = event
      const distX = pageX - pageXOld
      const distY = pageY - pageYOld
      let width = widthOld + distX
      let height = heightOld + distY
      const { screenWidth, screenHeight } = BenModalFn.getScreenSize()
      const scrollTop = document.documentElement.scrollTop
      const maxX = screenWidth - marginRight
      const maxY = screenHeight - marginBottom + scrollTop
      if (width > minWidth && pageX < maxX) {
        modalObj.width = width
      } else if (width <= minWidth) {
        modalObj.width = minWidth
      } else if (pageX >= maxX) {
        modalObj.width = widthOld + (maxX - pageXOld)
      }
      if (height > minHeight && pageY < maxY) {
        modalObj.height = height
      } else if (height <= minHeight) {
        modalObj.height = minHeight
      } else if (pageY >= maxY) {
        modalObj.height = heightOld + (maxY - pageYOld)
      }
      BenModalFn.render(modalObj)
      return false
    }
  }

  /** create document mouse move event when topWrap mousedown */
  private static eventDocumentMouseMoveCreate(modalObj: Modal, distX, distY) {
    const { RTL, marginBottom, marginLeft, marginRight, width, height } = modalObj
    const { screenWidth, screenHeight } = BenModalFn.getScreenSize()
    const maxX = screenWidth - width - marginRight
    const maxY = screenHeight - height - marginBottom
    return (event) => {
      event.preventDefault()
      event.stopPropagation()
      const { pageX, pageY } = event
      let left = pageX - distX
      let top = pageY - distY
      if (RTL) left = screenWidth - left - width
      modalObj.left = left
      modalObj.top = top
      BenModalFn.render(modalObj)
      return false
    }
  }
}

function _css(dom: HTMLElement, style: { [key: string]: string | number }) {
  if (!dom || !(dom instanceof HTMLElement)) return
  Object.entries(style).forEach(([key, value]) => {
    if (typeof value === 'number') value = value + 'px'
    const camelCaseKey = key.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase())
    dom.style[camelCaseKey as any] = value
  })
}
